<template>
    <div class="lg:flex lg:flex-auto lg:flex-col">
        <div
            v-if="daysWithEvents.length === 0"
            class="py-24 flex-col justify-start items-center flex"
        >
            <EmptyState
                icon="bed"
                title="No Award Availability"
                description="Try selecting a different date range or property."
                :show-animation="false"
                :hasAction="false"
            />
        </div>

        <ul v-else role="list" class="overflow-hidden bg-white">
            <li
                class="relative flex flex-wrap py-4 border-b border-slate-200 last:border-0"
                v-for="(day, dIndex) in daysWithEvents"
                :key="'day-' + dIndex"
            >
                <div class="w-full md:w-1/4 pt-3">
                    <p class="text-base leading-6 text-slate-500">
                        {{ day.date }}
                    </p>
                </div>
                <div class="flex w-full md:w-3/4">
                    <ol class="w-full flex flex-col divide-y divide-slate-200">
                        <ListItem
                            :event="event"
                            v-for="(event, eIndex) in day.events"
                            :key="'event-' + eIndex"
                        />
                    </ol>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import { mapState } from 'pinia';
import { useCalendarStore } from '@/store/calendar';
import ListItem from '@/components/calendar/partials/list-item.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';
import dayjs from 'dayjs';

export default {
    name: 'CalendarList',
    props: {
        size: {
            type: String,
            default: 'full', // full | mini
        },
        hidePastDates: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ListItem,
        EmptyState,
    },
    data: () => ({}),
    computed: {
        ...mapState(useCalendarStore, [
            'activeDate',
            'events',
            'startDate',
            'endDate',
            'nights',
        ]),
        daysWithEvents() {
            return this.currentMonthDays.filter((item) => {
                return item.events.length > 0;
            });
        },
        numberOfDaysInMonth() {
            return this.activeDate.daysInMonth();
        },
        currentMonthDays() {
            return [...Array(this.numberOfDaysInMonth)].map((day, index) => {
                let currentDate = dayjs(
                    `${this.activeDate.format('YYYY')}-${this.activeDate.format(
                        'MM'
                    )}-${index + 1}`
                );
                let isPastDate = currentDate.isBefore(dayjs(), 'day');
                if (this.hidePastDates && isPastDate) {
                    return { events: [] };
                }
                let dayDate = currentDate.format('YYYY-MM-DD');
                let events = this.events.filter((event) => {
                    return event.start_date === dayDate;
                });
                return {
                    date: currentDate.format('MMM D, ddd'),
                    dayLabel: currentDate.format('D'),
                    isCurrentMonth: true,
                    events: events,
                };
            });
        },
    },
};
</script>
